import http from '../http'

const api = {
    // 获取页面配置
    getPageInfo(params) {
        return http.get('/wp-json/dt_api/collection', {
            params,
        })
    },
}

const state = {
    banners: [],
    series: {
        data: [],
    },
    recommendedProducts: [],
}

const mutations = {
    GET_BANNERS: state => {
        return state
    },
    SET_BANNERS: (state, {banners}) => {
        state.banners = banners
    },
    SET_PAGE_TITLE: (state, {pageTitle}) => {
        state.pageTitle = pageTitle
    },
    SET_SERIES: (state, {series}) => {
        state.series = series
    },
    SET_RELATED_PRODUCTS: (state, {recommendedProducts}) => {
        state.recommendedProducts = recommendedProducts
    },
}

// 所有的mutations转换成actions进行调用
const actions = {
    async getPageInfo({commit}, slug) {
        commit('GET_BANNERS')
        const lang = window.localStorage.getItem('lang')

        await api.getPageInfo({
            slug: slug,
            lang,
        }).then(res => {
            if (res.data.data) {
                commit('SET_BANNERS', {
                    banners: res.data.data.banner_pictures,
                })
                commit('SET_PAGE_TITLE', {
                    pageTitle: res.data.data.title,
                })
                commit('SET_SERIES', {
                    series:{
                        data: [{
                            en_name: res.data.data.en_name,
                            cn_name: res.data.data.cn_name,
                            name: res.data.data.name,
                            title: res.data.data.name_in_title,
                            description: res.data.data.description,
                            subcategories: res.data.data.subcategories,
                        }]
                    },
                })

                commit('SET_RELATED_PRODUCTS', {
                    recommendedProducts: res.data.data.related_products,
                })

                commit('common/SET_PAGE_THEME',  {
                    theme: res.data.data.theme
                }, {root: true})
                commit('common/SET_THEME',  {
                    theme: res.data.data.theme,
                    wxShare: res.data.data.wechat_share,
                }, {root: true})
            }
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
